export const graphqlBaseUrl = "";
// export const baseUrl = process.env.REACT_APP_BACKEND_URL;
// export const baseUrl = "http://localhost:3092/graphql/users";
export const baseUrl = "https://api-bingo.classnotes.co/graphql/users";
export const appName = process.env.REACT_APP_PROJECT_NAME;
